import { EventType } from "@formant/core/model/EventType";
import { eventTypes } from "@formant/core/model/eventTypes";
import { IFilter } from "@formant/core/model/IFilter";

export const seekOptions = [
    "Notifications",
    "Comments",
    "Annotations",
    "Commands",
    "Data presence",
    "All other events",
] as const;

export type SeekOption = (typeof seekOptions)[number];

const commentEventTypes: EventType[] = ["comment"];
const annotationEventTypes: EventType[] = ["annotation"];
const commandEventTypes: EventType[] = [
    "command-request",
    "command-delivery",
    "command-response",
];
export const notificationEventTypes: EventType[] = [
    "triggered-event",
    "intervention-request",
    "datapoint-event",
    "custom",
    "stateful",
];

const specificEventTypes = [
    ...commentEventTypes,
    ...annotationEventTypes,
    ...commandEventTypes,
    ...notificationEventTypes,
];
const allOtherEventTypes = eventTypes.filter(
    _ => !specificEventTypes.includes(_),
);

export function seekOptionToEventTypes(
    seekOption:
        | "Notifications"
        | "Comments"
        | "Annotations"
        | "Commands"
        | "All other events",
): EventType[] {
    switch (seekOption) {
        case "Notifications":
            return notificationEventTypes;
        case "Comments":
            return commentEventTypes;
        case "Annotations":
            return annotationEventTypes;
        case "Commands":
            return commandEventTypes;
        case "All other events":
            return allOtherEventTypes;
    }
}

export function eventTypeToSeekOption(eventType: EventType): SeekOption {
    switch (eventType) {
        case "triggered-event":
        case "intervention-request":
        case "datapoint-event":
            return "Notifications";
        case "comment":
            return "Comments";
        case "annotation":
            return "Annotations";
        case "command-request":
        case "command-response":
        case "command-delivery":
            return "Commands";
        default:
            return "All other events";
    }
}

export const seekFilterExcludedStreams: IFilter = {
    notNames: [
        "$.agent.health",
        "$.host.cpu_util_percent",
        "$.host.load_avg_1min",
        "$.host.mem_used_percent",
        "$.host.net_util_tx_mbps",
        "$.host.net_util_rx_mbps",
        "$.ros.node_online",
    ],
};

export const seekOptionToNoun = (seekOption: SeekOption): string => {
    return {
        Notifications: "notification",
        Comments: "comment",
        Annotations: "annotation",
        Commands: "command",
        "Data presence": "data point",
        "All other events": "event",
    }[seekOption];
};
